var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lk-spin',{attrs:{"fix":""}},[_c('lk-icon',{staticClass:"demo-spin-icon-load",attrs:{"custom":"iconfont i-icon-loading","size":"36"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }